import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../Dashborad/client.css";
import ViewDescription from "./ViewDescription";
import moment from "moment";
import ViewSurvey from "./ViewSurvey";
import CommentModal from "./CommentModal";
import { useTranslation } from "react-i18next";
import SummaryComponent from "./SummaryComponent";
import { CheckIcon } from "../common/icon";

const DoctorPast = (props) => {
  const { t } = useTranslation();
  const {
    onSearchClick,
    originalSearchValue,
    pastDateFrom,
    pastDateTo,
    onPastDateRangeChange,
  } = props;
  const [summaryId, setSummaryId] = useState();
  const [description, setDescription] = useState();
  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const handleClose = () => setDescriptionOpen(false);
  const [updateSummaryResponce, setUpdateSummaryResponse] = useState({});
  const [prescriptionResponce, setUpdateProscriptionResponse] = useState([]);
  const [mid, setMId] = useState();
  const [cdata, setCdata] = useState();
  const [userName, setUserName] = useState("");
  const [checkIDF, setCheckIDF] = useState("");
  const [currentUserData, setCurrentUserData] = useState();
  const [doctorData, setDoctorData] = useState();
  const [hasMeetingType, setHasMeetingType] = useState(false);
  const [meetingType, setMeetingType] = useState("");
  const [meetingData, setMeetingData] = useState("");
  const [isSyrup, setIsSyrup] = useState([]);
  const [searchPatient, setSearchPatient] = useState("");

  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const summaryModal = (e, id, prescription, summary, data) => {
    e.preventDefault();
    setCurrentUserData(data?.userDetails);
    setDoctorData(data?.doctorDetails);
    setUserName(
      `${data?.userDetails?.first_name}  ${data?.userDetails?.last_name}`
    );
    setCheckIDF(data?.consultation[0]?.meetingGroupId);
    setSummaryId(id);
    setUpdateSummaryResponse(summary);
    setUpdateProscriptionResponse(prescription);
    setHasMeetingType(
      Object.prototype.hasOwnProperty.call(data, "meetingType")
    );
    setMeetingType(data?.meetingType || "");
    setMeetingData(data);
    props.setOpen(true);
  };

  const descriptionModal = (e, d) => {
    e.preventDefault();
    setDescription(d);
    setDescriptionOpen(true);
  };

  function ageCalculator(d) {
    var birthDate = new Date(d);
    var otherDate = new Date();

    var years = otherDate.getFullYear() - birthDate.getFullYear();

    if (
      otherDate.getMonth() < birthDate.getMonth() ||
      (otherDate.getMonth() == birthDate.getMonth() &&
        otherDate.getDate() < birthDate.getDate())
    ) {
      years--;
    }
    return years;
  }
  const handleCloseSumm = () => {
    props.handleCloseSummary();
    setUpdateSummaryResponse({});
  };
  const parseYMDToDate = (s) => {
    if (!s || typeof s !== "string") return null;
    const d = moment(s, "YYYY-MM-DD", true);
    return d.isValid() ? d.toDate() : null;
  };

  const handleDateRangeChange = (range) => {
    if (!onPastDateRangeChange) return;
    if (!range || (!range[0] && !range[1])) {
      onPastDateRangeChange("", "");
      setSearchPatient("");
      return;
    }
    const [start, end] = range;
    if (!start || !end) {
      onPastDateRangeChange(
        start ? moment(start).format("YYYY-MM-DD") : "",
        end ? moment(end).format("YYYY-MM-DD") : ""
      );
      return;
    }
    onPastDateRangeChange(
      moment(start).format("YYYY-MM-DD"),
      moment(end).format("YYYY-MM-DD")
    );
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearchPatient(value);
  };

  useEffect(() => {
    if (originalSearchValue !== undefined) {
      setSearchPatient(originalSearchValue);
    }
  }, [originalSearchValue]);

  const listData = props?.allAppointment || [];

  return (
    <div>
      <SummaryComponent
        open={props.open}
        updateSummaryResponce={updateSummaryResponce}
        setUpdateSummaryResponse={setUpdateSummaryResponse}
        prescriptionResponce={prescriptionResponce}
        setOpen={props.setOpen}
        meetingId={summaryId}
        handleClose={handleCloseSumm}
        AllApoinmentDoctor={props.AllApoinmentDoctor}
        setMeetingValue={props.setMeetingValue}
        meetingValue={props.meetingValue}
        userName={userName}
        checkIDF={checkIDF}
        userData={currentUserData}
        doctorData={doctorData}
        hasMeetingType={hasMeetingType}
        meetingType={meetingType}
        usesYarpaProvider={props.usesYarpaProvider}
        meetingData={meetingData}
        isSyrup={isSyrup}
        setIsSyrup={setIsSyrup}
      />
      <ViewDescription
        description={description}
        descriptionOpen={descriptionOpen}
        handleClose={handleClose}
      />
      <ViewSurvey
        medicalq={props.medicalq}
        handleClose={props.handleClose5}
        qData={props.qData}
      />
      <CommentModal
        handleClose={props.handleClose2}
        open={props.comentModal}
        mid={mid}
        cdata={cdata}
        note={props.note}
        setNote={props.setNote}
      />

      <section className="userWrapper doctor-user">
        <div className="container">
          <div className="row">
            <div className="customDatePickerContainer">
              <div className="custom-date-picker">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={parseYMDToDate(pastDateFrom)}
                  startDate={parseYMDToDate(pastDateFrom)}
                  endDate={parseYMDToDate(pastDateTo)}
                  onChange={(e) => handleDateRangeChange(e)}
                  dayPlaceholder="DD"
                  monthPlaceholder="MM"
                  yearPlaceholder="YYYY"
                  maxDate={new Date()}
                  selectsRange
                  isClearable
                  showIcon
                  className="custom-date-range"
                  placeholderText="Click to select  dates"
                  showPopperArrow={false}
                  locale="he"
                />
              </div>

              <div className="userSearchBox" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <div style={{ position: "relative", flex: 1 }}>
                  <input
                    type="text"
                    placeholder={t("Search")}
                    value={searchPatient}
                    onChange={handleSearchChange}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && onSearchClick) {
                        e.preventDefault();
                        onSearchClick(searchPatient);
                      }
                    }}
                    onBlur={() => {
                      if (onSearchClick) {
                        onSearchClick(searchPatient);
                      }
                    }}
                    className="search-input "
                    style={{ width: "100%", paddingRight: "20px" }}
                  />
                  <button
                    type="button"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => {
                      setSearchPatient("");
                      if (onSearchClick) {
                        onSearchClick("");
                      }
                    }}
                    style={{
                      position: "absolute",
                      right: "4px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      padding: "0 4px",
                      backgroundColor: "transparent",
                      color: "#999",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "14px",
                      lineHeight: "1"
                    }}
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="userInnerWrapper userInnerWrapB">
                {props.loader ? (
                  <h2>{t("Please wait")} ...</h2>
                ) : (
                  <ul>
                    {listData.length !== 0 ? (
                      listData &&
                      listData
                        .sort(
                          (objA, objB) =>
                            new Date(objB.scheduledDate) -
                            new Date(objA.scheduledDate)
                        )
                        .map((data, i) => {
                          return (
                            <li key={i}>
                              <div className="cfBase">
                                <div className="cfFirst">
                                  <div className="cfImgbg">
                                    <div className="cfImgTxt">
                                      <h3>{t("Patient")}</h3>
                                      <h2>
                                        {data?.patientDetails
                                          ? data?.patientDetails.first_name
                                          : ""}{" "}
                                        {data?.patientDetails
                                          ? data?.patientDetails.last_name
                                          : ""}
                                      </h2>
                                      {data?.consultation?.[0]
                                        ?.meetingGroupId && (
                                          <h4>
                                            {t(" Id")}-{data?.userDetails?.id}
                                          </h4>
                                        )}
                                      <h4>
                                        {t("Age")}-
                                        {data?.patientDetails?.patientDOB
                                          ? ageCalculator(
                                            data.patientDetails.patientDOB
                                          )
                                          : t("N/A")}
                                      </h4>
                                      <h4>
                                        {t("Gender")}-
                                        {t(data?.patientDetails?.patientGender)}
                                      </h4>
                                    </div>
                                  </div>
                                  <div className="cfDate">
                                    <h3>
                                      {moment(data?.scheduledDate).format(
                                        "DD.MM.YYYY"
                                      )}
                                    </h3>
                                    <span>
                                      {moment(data?.scheduledDate).format(
                                        "HH:mm"
                                      )}
                                    </span>
                                    <span>
                                      {" "}
                                      {t(
                                        weekday[
                                        new Date(data?.scheduledDate).getDay()
                                        ]
                                      )}
                                    </span>
                                    {data?.isFollowUp ? (
                                      <h4 className="followup-text">
                                        {t("Follow Up Meeting")}
                                      </h4>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="cflast">
                                  <div className="cfInfo">
                                    <div className="cfChk">
                                      {data.summary ? (
                                        <>
                                          <CheckIcon />
                                          <h3 className="active">
                                            {" "}
                                            {t("Summary/Prescription")}
                                          </h3>
                                        </>
                                      ) : (
                                        <h3 className="active no_document">
                                          {" "}
                                          {t("Summary/Prescription")}
                                        </h3>
                                      )}
                                    </div>
                                    {data.summary ? (
                                      <button
                                        className="active"
                                        onClick={(e) =>
                                          summaryModal(
                                            e,
                                            data._id,
                                            data?.prescription,
                                            data?.summary,
                                            data
                                          )
                                        }
                                      >
                                        {t("update")}
                                      </button>
                                    ) : (
                                      <button
                                        className="active"
                                        style={{
                                          background: "gray",
                                          width: "75px",
                                        }}
                                        onClick={(e) =>
                                          summaryModal(
                                            e,
                                            data._id,
                                            data?.prescription,
                                            data?.summary,
                                            data
                                          )
                                        }
                                      >
                                        {t("not ready")}
                                      </button>
                                    )}
                                  </div>
                                  <div className="cfInfo">
                                    <div className="cfChk">
                                      {data.requestDescription ? (
                                        <>
                                          <CheckIcon />
                                          <h3 className="active">
                                            {" "}
                                            {t("Request description")}
                                          </h3>
                                        </>
                                      ) : (
                                        <h3 className="active no_document">
                                          {" "}
                                          {t("Request description")}
                                        </h3>
                                      )}
                                    </div>
                                    {data.requestDescription ? (
                                      <button
                                        className="active"
                                        onClick={(e) =>
                                          descriptionModal(
                                            e,
                                            data.requestDescription
                                          )
                                        }
                                      >
                                        {t("View")}
                                      </button>
                                    ) : (
                                      <button
                                        className="active"
                                        style={{
                                          background: "gray",
                                          width: "75px",
                                        }}
                                        onClick={(e) =>
                                          summaryModal(e, data._id)
                                        }
                                      >
                                        {t("not ready")}
                                      </button>
                                    )}
                                  </div>
                                  <div className="cfInfo">
                                    <div className="cfChk">
                                      {data.survey?.mainComplaint ||
                                        data.survey?.medicalHistory ||
                                        data.survey?.medications ? (
                                        <>
                                          <CheckIcon />
                                          <h3 className="active ">
                                            {t("Medical questionnaire")}
                                          </h3>
                                        </>
                                      ) : (
                                        <h3 className="active no_document">
                                          {t("Medical questionnaire")}
                                        </h3>
                                      )}
                                    </div>
                                    {data.survey?.mainComplaint ||
                                      data.survey?.medicalHistory ||
                                      data.survey?.medications ? (
                                      <button
                                        className="active"
                                        onClick={() => (
                                          props.setMedicalQ(true),
                                          props.setQData(data.survey)
                                        )}
                                      >
                                        {t("View")}
                                      </button>
                                    ) : (
                                      <button
                                        className="active"
                                        style={{
                                          background: "gray",
                                          width: "75px",
                                        }}
                                      >
                                        {t("not ready")}
                                      </button>
                                    )}
                                  </div>
                                  <div className="cfInfo">
                                    {data?.comments ? (
                                      <div className="cfChk">
                                        <CheckIcon />
                                        <h3 className="active ">
                                          {t("Meeting comments")}
                                        </h3>
                                      </div>
                                    ) : (
                                      <div className="cfChk">
                                        <h3 className="active no_document">
                                          {t("Meeting comments")}
                                        </h3>
                                      </div>
                                    )}
                                    {data?.comments ? (
                                      <button
                                        className="active"
                                        onClick={() => (
                                          props.setCommentModal(true),
                                          setMId(data._id),
                                          setCdata(data.comments.doctorComment),
                                          props.setNote(
                                            data?.comments?.doctorComment
                                          )
                                        )}
                                      >
                                        {t("update")}
                                      </button>
                                    ) : (
                                      <button
                                        className="active"
                                        style={{
                                          background: "gray",
                                          width: "75px",
                                        }}
                                        onClick={() => (
                                          props.setCommentModal(true),
                                          setMId(data._id)
                                        )}
                                      >
                                        {t("add")}
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </li>
                          );
                        })
                    ) : (
                      <h3 className="no_meeting">
                        {t("You have no past meeting")}
                      </h3>
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default DoctorPast;
